class GenericExceptions extends Error{
    constructor(message) {
      super(message); 
    }
}
export default GenericExceptions;
